module.exports = __webpack_public_path__ + "static/media/Rodrigo.4b6c6d37.jpg";